import React from "react";
import TopNavBar from "../../../components/ui/TopNavBar";
import ChainedContext from "../../../contexts/chainedContext";
import SettingsReceiver from "../../../contexts/settings_context/Settings_Receiver";

function RotasNav({ settings }) {
  const navigation = [
    { name: "Dashboard", href: `/rotas`, exact: true, show: true },
    { name: "Schedule", href: `/rotas/schedule`, exact: true, show: true },
    { name: "Calendar", href: `/rotas/calendar`, exact: true, show: true },
    // { name: "Member Activity", href: `/reports/member_activity`, exact: true, show: true },
    // { name: "Member Deployments", href: `/reports/member_deployments`, exact: true, show: true },
    // { name: "Lowland Report", href: `/reports/lowland_report`, exact: true, show: settings.enableLowlandReport },
  ];

  return (
    <TopNavBar navigation={navigation} title={"Rotas"} />
  );
}
export default ChainedContext(RotasNav, [
  [SettingsReceiver, "settings"]
]);